import { render, staticRenderFns } from "./BarGraph.vue?vue&type=template&id=83c9c076"
import script from "./BarGraph.vue?vue&type=script&lang=ts"
export * from "./BarGraph.vue?vue&type=script&lang=ts"
import style0 from "./BarGraph.vue?vue&type=style&index=0&id=83c9c076&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports